export const domain = {
    name:"Mijn InternetOplossing B.V.",
    address:"Winthontlaan 200 3526 KV Utrecht Netherlands",
    link: "www.mijnwebserver.nl",
    email:"info@mijnwebserver.nl"
  };